export default __webpack_public_path__ + "static/media/M2Doubts2.717abbdb.png";